import { call, put } from 'redux-saga/effects';

import {
	getStoreDrillDownDataFailure,
	getStoreDrillDownDataSuccess,
} from '../../../actions/storeDrillDownActions';
import { fetchStoreDrillMetricsData } from '../queries/guided-Insights/store-drill-down/store-drill-down-query';
import { transformStoreDrillData } from '../transformers/transform-store-drill-response';

export function* getStoreDrillDownData(action) {
	const { request, threshold, itemId, period } = action?.payload || {}; // Add a fallback to an empty object
	try {
		const payload = {
			ids: [itemId],
			...request,
		};
		const federatedMetricsResponse = yield call(
			fetchStoreDrillMetricsData,
			payload,
			threshold,
			period
		);
		const response = transformStoreDrillData(
			federatedMetricsResponse?.data?.federatedMetricValuesV1?.edges
		);
		yield put(getStoreDrillDownDataSuccess(response));
	} catch (error) {
		yield put(getStoreDrillDownDataFailure('error'));
	}
}
